import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  STOCK_TAKING_CAR_MANAGEMENT_DETAILS_DATA_MASTER_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_DETAILS_DATA_MASTER_FAILURE
} from '../constants'

export function* getCarDetailDataMasterSaga({data:{versionId}}) {
  try {
      
    if(versionId){
      const result =  yield call(BFFAgent.Datamasters.getAuto, versionId)
      const carInfo = result

      yield put({
          type: STOCK_TAKING_CAR_MANAGEMENT_DETAILS_DATA_MASTER_SUCCESS,
          data: carInfo
      })

    } else {

      yield put({
        type: STOCK_TAKING_CAR_MANAGEMENT_DETAILS_DATA_MASTER_FAILURE,
        data: { error: 'Se necesita el Id del vehículo (idVersion)' }
      })
      
    }
      
  } catch (error) {
      yield put({
      type: STOCK_TAKING_CAR_MANAGEMENT_DETAILS_DATA_MASTER_FAILURE,
      data: { error }
      
    })
  }
}
